import { Stage, stageFromString } from '@eventbrite/webapp-constants';
import { SUPPORTED_TLDS } from '@eventbrite/legacy-infra.i18n/constants';
import { HAS_WINDOW } from '../has-window';
import { DOMAINS_STAGES, DOMAINS } from './constants';

const TLD_MATCH = Object.keys(SUPPORTED_TLDS)
    .map((tld) => tld.replace('.', '\\.'))
    .join('|');
const SLD_MATCH = DOMAINS.join('|');
const DOMAIN_MATCH = new RegExp(`(?:[a-zA-Z0-9-]+\.)*(?:(${SLD_MATCH})\.(${TLD_MATCH}))$`);

export const getCurrentEnv = (): Stage | null => {
    let stage: string | null = null;
    if (HAS_WINDOW) {
        // If on the browser, determine stage based on URL
        const { hostname } = new URL(window.location.href);
        let domain: string | null;

        if (hostname === 'localhost') {
            domain = hostname;
        } else {
            const match = hostname.match(DOMAIN_MATCH);
            domain = match && match[1] ? match[1] : null;
        }

        if (domain && DOMAINS_STAGES[domain]) {
            stage = DOMAINS_STAGES[domain];
        }
    } else {
        // Otherwise, determine stage based on `process.env.STAGE`
        stage = process.env.STAGE || null;
    }

    // Attempt to return a Stage if we have one.
    // `stageFromString` throws an error on invalid stage names
    if (stage) {
        try {
            return stageFromString(stage);
        } catch (e) {
            return null;
        }
    }

    return null;
};
